const AuthenticationType = {
    hmac: 'HMAC',
    token: 'Token',
};

export default AuthenticationType;
